<!--  <div class="search"><i class="pi pi-search" style="font-size: 1rem"></i></div>-->

  <!-- Mobile-only: opens the navigation drawer (hidden on desktop via CSS). -->
  <button type="button" class="nav-hamburger" (click)="openSidenav()"
          [attr.aria-label]="'nav.openMenu' | translate">
    <i class="pi pi-bars"></i>
  </button>

<div class="nav-actions">
  <div class="locale"><app-locale-picker /></div>
  <div class="notification"><app-notification-bell /></div>
</div>

<span class="nav-divider"></span>

<p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" />
<div
  class="profile"
  role="button"
  tabindex="0"
  [attr.aria-label]="'nav.profile' | translate"
  (click)="menu.toggle($event)"
  (keydown.enter)="menu.toggle($event)"
  (keydown.space)="menu.toggle($event)"
>
  <p-image
    src="/images/profile.png"
    alt="Image"
    width="32"
  >
    <ng-template pTemplate="indicator">
      <i class="pi pi-check"></i>
    </ng-template>
  </p-image>
  <span class="profile-name" *ngIf="userName">{{ userName }}</span>
  <i class="pi pi-angle-down profile-caret"></i>
</div>
